import 'whatwg-fetch';

export interface ClientRequest<T = object> {
  data?: T;
  token?: string;
  config?: RequestInit & {
    isTokenRequired?: boolean;
  };
}

export async function client<TResponse = unknown, TRequest = unknown>(
  endpoint: string,
  { data, token, config }: ClientRequest<TRequest> = {
    config: {
      isTokenRequired: true,
    },
  },
): Promise<TResponse> {
  const isFormData = data instanceof FormData;

  const customConfig: RequestInit = {
    method: data ? 'POST' : 'GET',
    body: isFormData ? data : JSON.stringify(data),
    headers: {
      ...(config?.isTokenRequired && token && { Authorization: `Bearer ${token}` }),
      // Only set 'Content-Type' header if data is not FormData
      ...(data && !isFormData && { 'Content-Type': 'application/json' }),
      ...config?.headers,
    },
    ...config,
  };

  return fetch(endpoint, customConfig).then(async response => {
    if (response.ok) {
      if (response.status === 204) {
        return {} as TResponse;
      }
      return (await response.json()) as TResponse;
    } else {
      return Promise.reject('error');
    }
  });
}
